import isVisible from './is-visible';

export default {
  isVisible,
};
